import { APP_PDC_URL, APP_NAME } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { getUID, getName } from "../../services/tokenFunc";

export const notesConstants = {
  CREATE_NOTE_START: "CREATE_NOTE_START",
  CREATE_NOTE_SUCCESS: "CREATE_NOTE_SUCCESS",
  CREATE_NOTE_ERROR: "CREATE_NOTE_ERROR",
  MODIFY_NOTE_NEW_START: "MODIFY_NOTE_NEW_START",
  MODIFY_NOTE_NEW_SUCCESS: "MODIFY_NOTE_NEW_SUCCESS",
  MODIFY_NOTE_NEW_ERROR: "MODIFY_NOTE_NEW_ERROR",
  DELETE_NOTE_START: "DELETE_NOTE_START",
  DELETE_NOTE_SUCCESS: "DELETE_NOTE_SUCCESS",
  DELETE_NOTE_ERROR: "DELETE_NOTE_ERROR",
  RESET_NOTE: "RESET_NOTE"
};

export function resetNote() {
  return function(dispatch) {
    dispatch({
      type: notesConstants.RESET_NOTE
    });
  };
}

export function createNote(documentId,
  noteText) {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const accountantIdSelected = getState().main.accountantIdSelected;
    const clientIdSelected = getState().main.clientIdSelected;
    const userType = getState().main.myType;
    let request = {
      method: "POST",
      url: `${APP_PDC_URL}/v2/documents/${documentId}/notes`,
      headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
      data: {
        itemId: clientIdSelected,
        accountantId: accountantIdSelected,
        documentSource: APP_NAME,
        note: noteText,
        type: userType
      }
    };
    return new Promise(function(resolve, reject) {
      dispatch({
        type: notesConstants.CREATE_NOTE_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          const uid = getUID(auth.loginAuth.securityToken);
          const userName = getName(auth.loginAuth.securityToken);
          dispatch({
            type: notesConstants.CREATE_NOTE_SUCCESS,
            /* scope,*/
            payload: {
              id: result.data.putNote.message,
              createdBy: uid,
              createdOn: new Date(),
              updatedOn: null,
              userName: userName,
              noteText: noteText,
              itemClassifier: userType,
              documentID: documentId
            }
          });
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: notesConstants.CREATE_NOTE_ERROR,
            payload: {
              message: "Si è verificato un errore",
              code: response && response.code ? response.code : 500
            }
          });
          reject(response);
        });
    });
  };
}

export function deleteNote(
  auth,
  accountantSelected,
  accountantIdSelected,
  companySelected,
  clientIdSelected,
  documentId,
  noteID
) {
  let request = {
    method: "DELETE",
    url: `${APP_PDC_URL}/v2/documents/${documentId}/notes/${noteID}?itemId=${clientIdSelected}&accountantId=${accountantIdSelected}`,
    headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
  };

  return dispatch => {
    return new Promise(function(resolve, reject) {
      dispatch({
        type: notesConstants.DELETE_NOTE_START,
        payload: { noteID: noteID }
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          dispatch({
            type: notesConstants.DELETE_NOTE_SUCCESS,
            /* scope,*/
            payload: {
              ...result.data,
              documentID: documentId,
              noteID: noteID
            }
          });
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: notesConstants.DELETE_NOTE_ERROR,
            payload: {
              message: "Si è verificato un errore",
              code: response && response.code ? response.code : 500
            }
          });
          reject(response);
        });
    });
  };
}

export function modifyNote(
  auth,
  accountantSelected,
  accountantIdSelected,
  companySelected,
  clientIdSelected,
  documentId,
  noteID,
  noteText,
  userType,
  scope
) {
  let request = {
    method: "PUT",
    url: `${APP_PDC_URL}/v2/documents/${documentId}/notes/${noteID}`,
    headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
    data: {
      itemId: clientIdSelected,
      accountantId: accountantIdSelected,
      documentSource: APP_NAME,
      note: noteText,
      type: userType
    }
  };

  return dispatch => {
    return new Promise(function(resolve, reject) {
      dispatch({
        type: notesConstants.MODIFY_NOTE_NEW_START,
        payload: { id: noteID }
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          dispatch({
            type: notesConstants.MODIFY_NOTE_NEW_SUCCESS,
            /* scope,*/
            payload: {
              noteId: noteID,
              noteText: noteText,
              documentID: documentId
            }
          });
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: notesConstants.MODIFY_NOTE_NEW_ERROR,
            payload: {
              message: "Si è verificato un errore",
              code: response && response.code ? response.code : 500
            }
          });
          reject(response);
        });
    });
  };
}
